module.exports = __webpack_public_path__ + "img/sjyy.3b3cd25d.png";